var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.794 11.6875C13.2292 12.0105 13.4583 12.377 13.4583 12.75C13.4583 13.123 13.2292 13.4895 12.794 13.8125C12.3588 14.1355 11.7329 14.4038 10.9791 14.5903C10.2254 14.7768 9.37033 14.875 8.49996 14.875C7.62959 14.875 6.77455 14.7768 6.02079 14.5903C5.26703 14.4038 4.6411 14.1355 4.20592 13.8125C3.77073 13.4895 3.54163 13.123 3.54163 12.75C3.54163 12.377 3.77073 12.0105 4.20592 11.6875",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0417 6.37467C11.0417 7.7784 9.90376 8.91634 8.50004 8.91634C7.09632 8.91634 5.95837 7.7784 5.95837 6.37467C5.95837 4.97095 7.09632 3.83301 8.50004 3.83301C9.90376 3.83301 11.0417 4.97095 11.0417 6.37467Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.0413C7.5 12.5936 7.94772 13.0413 8.5 13.0413C9.05228 13.0413 9.5 12.5936 9.5 12.0413L7.5 12.0413ZM7.5 9.20801L7.5 12.0413L9.5 12.0413L9.5 9.20801L7.5 9.20801Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b90bf36e2de09821122038e17399f76f.svg";
export { ForwardRef as ReactComponent };